module.exports = __webpack_public_path__ + "static/media/rotating-earth.126ca6bc.gif";